import { Button } from '../../../ui';

const GetMarketingPlan = ({ showModal }) => {
  return (
    <div className="bg-[#EEEAF9] md:py-[43px] pt-[92px] pb-[48px] px-[24px] overflow-hidden">
      <div className="container">
        <div className="flex md:flex-row flex-col-reverse items-center pl-[20px] gap-[110px]">
          <div className="relative mr">
            <img className="relative z-10 max-w-[430px] max-h-[263px] md:block hidden" src="/images/blog/comp.webp" alt="comp" />
            <img className="relative z-10 max-w-[344px] max-h-[263px] md:hidden block" src="/images/blog/comp-mob.png" alt="comp" />

            <img
              className="absolute z-20 md:top-0 top-[-25px] md:-translate-x-1/2 -translate-x-1/3 md:w-[84px] w-[64px] "
              src="/images/blog/p1.png"
              alt="comp"
            />
            <img
              className="absolute z-20 md:bottom-0 bottom-[-30px] right-[35px] md:right-0 md:translate-x-1/2 translate-x-1/2 md:w-[116px] w-[93px]"
              src="/images/blog/p2.png"
              alt="comp"
            />
            <img
              className="absolute z-20 md:bottom-0 md:top-0 top-[-50px] md:right-0 right-[10px] w-[100px] translate-x-1/3"
              src="/images/blog/p3.png"
              alt="comp"
            />
            <img
              className="absolute w-[77px] z-20 md:bottom-0 bottom-[-30px] md:left-0 left-[40px] -translate-x-1/3"
              src="/images/blog/p4.png"
              alt="comp"
            />
          </div>
          <div className="flex-1 flex justify-center items-center gap-[16px] flex-col ">
            <p className="text-[34px] font-[600] leading-[42px] text-center"> Better Marketing Peformance Is Ready For You - Are You?</p>

            <Button variant="primary" narrowing="both" mode="light" className=" md:text-[18px] text-[15px]" onClick={showModal}>
              Get a Free Marketing Plan
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetMarketingPlan;
